import type { RegionThumbnailFragment } from "../client/generated";
import type { ComponentProps } from "react";
import { cn } from "@acdc2/ui/lib/utils";
import { RegionImage } from "./RegionImage";
import { getRegionType } from "../types/utils";

type Props = ComponentProps<"div"> & {
  fragment: RegionThumbnailFragment;
};

export function RegionThumbnail({ fragment, className, ...props }: Props) {
  const regionKind = getRegionType(fragment);
  const viewBoxWidth = fragment.shape.aabb.width * fragment.page.width;
  const viewBoxHeight = fragment.shape.aabb.height * fragment.page.height;

  return (
    <div
      className={cn(
        "min-h-16 flex flex-col justify-center bg-linear-to-r p-2",
        {
          "from-region-untyped-max to-region-untyped-min":
            regionKind === "untyped",
          "from-region-hybrid-max to-region-hybrid-min":
            regionKind === "hybrid",
          "from-region-heading-max to-region-heading-min":
            regionKind === "heading",
          "from-region-caption-max to-region-caption-min":
            regionKind === "caption",
          "from-region-formula-max to-region-formula-min":
            regionKind === "formula",
          "from-region-figure-max to-region-figure-min":
            regionKind === "figure",
          "from-region-image-max to-region-image-min": regionKind === "image",
          "from-region-list-max to-region-list-min":
            regionKind === "list" ||
            regionKind === "listItem" ||
            regionKind === "sublist",
          "from-region-artifact-max to-region-artifact-min":
            regionKind === "artifact",
          "from-region-table-max to-region-table-min": regionKind === "table",
          "from-region-toc-max to-region-toc-min": regionKind === "toc",
          "from-region-text-max to-region-text-min": regionKind === "text",
        },
        className,
      )}
      {...props}
    >
      <div
        className="mx-auto drop-shadow-lg"
        style={{ width: `${viewBoxWidth}in`, height: `${viewBoxHeight}in` }}
      >
        <RegionImage fragment={fragment} />
      </div>
    </div>
  );
}
